<div class="avi-main-header-user-card">
    <div class="avi-main-header-user-card__user-info-container">
        <div class="avi-main-header-user-card__user-icon-container">
            <cds-icon
                shape="user"
                inverse
                size="24"
                class="avi-main-header-user-card__user-icon"
            ></cds-icon>
        </div>
        <div class="avi-main-header-user-card__user-info">
            <div
                class="avi-main-header-user-card__full-name"
                title="{{ fullName || username }}"
            >
                {{ fullName || username }}
            </div>
            <div
                *ngIf="email"
                class="avi-main-header-user-card__email"
                title="{{ email }}"
            >
                {{ email }}
            </div>
            <div
                *ngIf="lastLogin"
                class="avi-main-header-user-card__last-login"
            >
                {{ l10nKeys.lastLoginLabel | vtranslate : lastLogin }}
            </div>
        </div>
    </div>
    <div class="avi-main-header-user-card__buttons-container">
        <!-- Workaround for handling keyup event from opening tooltip. Fix with AV-221491 -->
        <button
            class="btn btn-primary avi-main-header-user-card__my-account-button sel-my-account"
            (click)="onOpenMyAccountModal.emit()"
        >
            {{ l10nKeys.myAccountLabel | vtranslate }}
        </button>
        <cds-button
            action="outline"
            class="sel-generate-token"
            (click)="onOpenGenerateTokenDialog.emit()"
        >
            {{ l10nKeys.generateTokenLabel | vtranslate }}
        </cds-button>
    </div>
</div>
